export default __webpack_public_path__ + "static/media/mail.af00456f.svg";